/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  numeroCotacao: string;
}
export function useOportunidadesLeadDetalhe(props: Props) {
  const LISTAR_OPORTUNIDADE_DETALHE = `${backofficeEnviroment}/common/oportunidades-lead/detalhe/v1/${props.numeroCotacao}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_OPORTUNIDADE_DETALHE);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["oportunidades-lead-detalhe"],
    refetchOnWindowFocus: false,
  });
  return query;
}
